import Component from "./SpinningWheel";

export default Component;
